export const configuration = {
    role: ['manager', 'administrator'],
    show: false
};
